export const openUrl = (url: string, target?: '_blank' | '_self' | string) => {
    window.open(url, target);
};
